const seoConfig = {
  // === PUBLIC PAGES ===
  '/': {
    title: 'Hire Top 1% African Freelancers',
    description: 'CareerBuddyPro connects world-class African professionals with global companies. Find verified developers, designers, and marketers with payment protection.',
  },
  '/jobs': {
    title: 'Browse Freelance Jobs',
    description: 'Discover freelance jobs in development, design, marketing, and more. Find your next project on CareerBuddyPro.',
  },
  '/talent': {
    title: 'Find Top Talent',
    description: 'Browse verified freelancers in development, design, marketing, data, and more. Hire the best African talent.',
  },
  '/find-freelancers': {
    title: 'Find Freelancers',
    description: 'Search and hire skilled freelancers for your projects. Filter by skills, experience, and availability.',
  },
  '/find-talent': {
    title: 'Find Talent',
    description: 'Discover top-rated freelancers ready to work on your projects. Vetted professionals in every field.',
  },
  '/search/jobs': {
    title: 'Search Jobs',
    description: 'Advanced search for freelance jobs. Filter by budget, skills, location, and project type.',
  },
  '/search/freelancers': {
    title: 'Search Freelancers',
    description: 'Advanced search for freelancers. Filter by skills, hourly rate, experience level, and availability.',
  },

  // === SERVICE PAGES ===
  '/services': {
    title: 'Freelance Services',
    description: 'Explore our range of freelance services: web development, mobile apps, AI, design, marketing, and more.',
  },
  '/services/web-development': {
    title: 'Web Development Services',
    description: 'Hire expert web developers for React, Angular, Node.js, and full-stack projects. Vetted African talent.',
  },
  '/services/mobile-apps': {
    title: 'Mobile App Development',
    description: 'Build iOS and Android apps with top mobile developers. React Native, Flutter, and native expertise.',
  },
  '/services/ai-development': {
    title: 'AI & Machine Learning Services',
    description: 'Hire AI and machine learning specialists for your next project. NLP, computer vision, and data science experts.',
  },
  '/services/ai': {
    title: 'AI Services',
    description: 'Artificial intelligence development services. Machine learning, automation, and AI integration experts.',
  },
  '/services/marketing-automation': {
    title: 'Marketing Automation Services',
    description: 'Automate your marketing with expert freelancers. Email campaigns, CRM, and growth automation.',
  },
  '/services/technical-consulting': {
    title: 'Technical Consulting',
    description: 'Get expert technical advice from seasoned professionals. Architecture, code review, and strategy consulting.',
  },
  '/services/content-creation': {
    title: 'Content Creation Services',
    description: 'Hire content creators for blog posts, copywriting, social media, and video content.',
  },
  '/services/writing': {
    title: 'Writing & Content Services',
    description: 'Professional writers for copywriting, technical writing, blog content, and translations.',
  },
  '/services/design': {
    title: 'Design Services',
    description: 'UI/UX design, graphic design, brand identity, and creative services from top designers.',
  },
  '/services/digital-marketing': {
    title: 'Digital Marketing Services',
    description: 'SEO, PPC, social media marketing, and growth strategies from experienced marketers.',
  },
  '/services/marketing': {
    title: 'Marketing Services',
    description: 'Full-service digital marketing: SEO, content marketing, social media, and paid advertising.',
  },
  '/services/business-consulting': {
    title: 'Business Consulting',
    description: 'Strategic business consulting from experienced professionals. Growth, operations, and management.',
  },
  '/services/consulting': {
    title: 'Consulting Services',
    description: 'Expert consulting services across business, technology, and strategy.',
  },
  '/services/data-analytics': {
    title: 'Data Analytics Services',
    description: 'Data analytics, business intelligence, and visualization experts to unlock insights from your data.',
  },
  '/services/virtual-assistant': {
    title: 'Virtual Assistant Services',
    description: 'Hire virtual assistants for admin support, customer service, data entry, and research.',
  },

  // === INFORMATIONAL / MARKETING PAGES ===
  '/about': {
    title: 'About Us',
    description: 'Learn about CareerBuddyPro, our mission to connect African talent with global opportunities.',
  },
  '/how-it-works': {
    title: 'How It Works',
    description: 'Learn how CareerBuddyPro works for companies and freelancers. Post jobs, find talent, and collaborate.',
  },
  '/how-it-works-freelancers': {
    title: 'How It Works for Freelancers',
    description: 'Learn how to find work, submit proposals, and grow your freelance career on CareerBuddyPro.',
  },
  '/pricing': {
    title: 'Pricing',
    description: 'Transparent pricing for companies and freelancers. No hidden fees, competitive rates.',
  },
  '/contact': {
    title: 'Contact Us',
    description: 'Get in touch with CareerBuddyPro. Questions, support, or partnership inquiries.',
    canonicalPath: '/contact',
  },
  '/contact-us': {
    title: 'Contact Us',
    description: 'Get in touch with CareerBuddyPro. Questions, support, or partnership inquiries.',
    canonicalPath: '/contact',
  },
  '/trust-safety': {
    title: 'Trust & Safety',
    description: 'Learn about our trust and safety measures. Payment protection, verification, and dispute resolution.',
  },
  '/enterprise': {
    title: 'Enterprise Solutions',
    description: 'Enterprise-grade freelancer management. Custom onboarding, dedicated support, and compliance tools.',
  },
  '/for-companies': {
    title: 'For Companies',
    description: 'Hire top freelancers for your company. Streamlined hiring, contract management, and team collaboration.',
  },
  '/for-freelancers': {
    title: 'For Freelancers',
    description: 'Join CareerBuddyPro as a freelancer. Find global projects, get paid securely, and grow your career.',
  },
  '/join-as-talent': {
    title: 'Join as Talent',
    description: 'Join the top 5% of African GTM and technical freelancers. Serious clients, fair rates, payouts in 7 days and zero chasing invoices. Free to apply.',
  },
  '/manage-embedded': {
    title: 'Managed & Embedded Engagements',
    description: 'Brief us on the outcome — pipeline built, funnel fixed, inbox handled. We assemble the freelancer or squad, embed them in your tools, and stay accountable every week.',
  },
  '/for-agencies': {
    title: 'For Agencies',
    description: 'Partner with CareerBuddyPro as an agency. Manage your team, find projects, and scale your business.',
  },
  '/for-startups': {
    title: 'For Startups',
    description: 'Build your startup with vetted freelancers. Affordable talent for MVPs, design, and growth.',
  },
  '/careers': {
    title: 'Careers at CareerBuddyPro',
    description: 'Join our team. Explore open positions at CareerBuddyPro and help shape the future of work in Africa.',
  },
  '/press': {
    title: 'Press & Media',
    description: 'CareerBuddyPro news, press releases, and media resources.',
  },
  '/blog': {
    title: 'Blog',
    description: 'Insights, tips, and stories about freelancing, hiring, and the future of remote work in Africa.',
  },
  '/help': {
    title: 'Help Center',
    description: 'Find answers to your questions. Help articles, FAQs, and support resources.',
  },
  '/partners': {
    title: 'Partners',
    description: 'CareerBuddyPro partner programs and integrations.',
  },
  '/calculator': {
    title: 'Project Cost Calculator',
    description: 'Estimate your project cost. Get instant budget estimates for freelance projects.',
  },
  '/hiring-guide': {
    title: 'Hiring Guide',
    description: 'A complete guide to hiring freelancers. Best practices, tips, and strategies.',
  },
  '/freelancer-guide': {
    title: 'Freelancer Guide',
    description: 'A complete guide to freelancing on CareerBuddyPro. Profiles, proposals, and success tips.',
  },
  '/ai-features': {
    title: 'AI-Powered Features',
    description: 'Discover AI-powered job matching, proposal assistance, and smart recommendations.',
  },

  // === RESOURCE PAGES ===
  '/partner-networks': {
    title: 'Partner Networks',
    description: 'Explore our partner networks and integrations for enhanced collaboration.',
  },
  // '/blog-guides': {
  //   title: 'Blog & Guides',
  //   description: 'In-depth guides and blog posts on freelancing, hiring, and remote work.',
  // },
  '/project-calculator': {
    title: 'Project Calculator',
    description: 'Calculate project costs and timelines with our interactive estimator.',
  },
  '/remote-hiring-guide': {
    title: 'Remote Hiring Guide',
    description: 'Best practices for hiring and managing remote freelancers across Africa and beyond.',
  },
  '/freelancer-success-guide': {
    title: 'Freelancer Success Guide',
    description: 'Tips, strategies, and resources to build a successful freelance career.',
  },

  // === STATIC INFO PAGES ===
  '/how-to-hire': {
    title: 'How to Hire',
    description: 'Best practices to hire top freelancers on CareerBuddyPro.',
  },
  '/talent-marketplace': {
    title: 'Talent Marketplace',
    description: 'Browse categories and find specialized freelancers on our marketplace.',
  },
  '/project-catalog': {
    title: 'Project Catalog',
    description: 'Fixed-price projects you can start instantly. Curated packages at known prices.',
  },
  '/payroll-services': {
    title: 'Payroll Services',
    description: 'Compliance, payroll, and taxes handled for you. Global contractor management.',
  },
  '/how-to-find-work': {
    title: 'How to Find Work',
    description: 'Tips to stand out and win projects as a freelancer.',
  },
  '/direct-contracts': {
    title: 'Direct Contracts',
    description: 'Work with clients directly with platform protections. Escrow and low fees.',
  },
  '/find-freelance-jobs': {
    title: 'Find Freelance Jobs',
    description: 'Discover projects tailored to your skills with smart matching and filters.',
  },
  '/success-stories': {
    title: 'Success Stories',
    description: 'See how companies and freelancers thrive on CareerBuddyPro.',
  },
  '/resources': {
    title: 'Resources',
    description: 'Guides, templates, and tools for companies and freelancers.',
  },
  '/leadership': {
    title: 'Leadership',
    description: 'Meet the team behind CareerBuddyPro.',
  },
  '/investors': {
    title: 'Investor Relations',
    description: 'Financials, governance, and quarterly reports for CareerBuddyPro investors.',
  },

  // === LEGAL PAGES ===
  '/privacy': {
    title: 'Privacy Policy',
    description: 'CareerBuddyPro privacy policy. How we collect, use, and protect your data.',
    canonicalPath: '/privacy',
  },
  '/privacy-policy': {
    title: 'Privacy Policy',
    description: 'CareerBuddyPro privacy policy. How we collect, use, and protect your data.',
    canonicalPath: '/privacy',
  },
  '/terms': {
    title: 'Terms of Service',
    description: 'CareerBuddyPro terms of service. Rules and guidelines for using our platform.',
    canonicalPath: '/terms',
  },
  '/terms-of-service': {
    title: 'Terms of Service',
    description: 'CareerBuddyPro terms of service. Rules and guidelines for using our platform.',
    canonicalPath: '/terms',
  },
  '/cookies': {
    title: 'Cookie Policy',
    description: 'Cookies we use and your choices on CareerBuddyPro.',
  },
  '/accessibility': {
    title: 'Accessibility',
    description: 'Our commitment to inclusive and accessible design. WCAG 2.1 AA compliance.',
  },

  // === AUTH / PROTECTED PAGES (noIndex) ===
  '/login': { title: 'Log In', description: 'Log in to your CareerBuddyPro account.', noIndex: true },
  '/register': { title: 'Sign Up', description: 'Create your CareerBuddyPro account.', noIndex: true },
  '/signup': { title: 'Sign Up', description: 'Create your CareerBuddyPro account.', noIndex: true },
  '/verify-email': { title: 'Verify Email', description: 'Verify your email address.', noIndex: true },
  '/forgot-password': { title: 'Forgot Password', description: 'Reset your password.', noIndex: true },
  '/reset-password': { title: 'Reset Password', description: 'Set a new password.', noIndex: true },
  '/security': { title: 'Security Settings', description: 'Manage your security settings.', noIndex: true },
  '/post-job': { title: 'Post a Job', description: 'Post a new freelance job.', noIndex: true },
  '/escrow': { title: 'Escrow', description: 'Manage escrow payments.', noIndex: true },
  '/settings': { title: 'Settings', description: 'Manage your account settings.', noIndex: true },
  '/messages': { title: 'Messages', description: 'Your conversations.', noIndex: true },
  '/negotiation': { title: 'Negotiation', description: 'Negotiate project terms.', noIndex: true },
  '/deliverables': { title: 'Deliverables', description: 'Manage deliverables.', noIndex: true },
  '/contracts': { title: 'Contracts', description: 'Manage your contracts.', noIndex: true },
  '/proposals': { title: 'Proposals', description: 'Manage your proposals.', noIndex: true },
  '/my-jobs': { title: 'My Jobs', description: 'View your jobs.', noIndex: true },
  '/taskboard': { title: 'Task Board', description: 'Manage your tasks.', noIndex: true },
  '/manage-project': { title: 'Manage Project', description: 'Project management dashboard.', noIndex: true },
  '/recommendations': { title: 'Recommendations', description: 'Personalized recommendations.', noIndex: true },
  '/alerts': { title: 'Alerts', description: 'Your alerts and notifications.', noIndex: true },
  '/vetting': { title: 'Vetting', description: 'Freelancer vetting process.', noIndex: true },
  '/agencies': { title: 'Agencies', description: 'Agency management.', noIndex: true },
  '/notifications': { title: 'Notifications', description: 'Notification preferences.', noIndex: true },
  '/wallet': { title: 'Wallet', description: 'Manage your wallet.', noIndex: true },
  '/saved-searches': { title: 'Saved Searches', description: 'Your saved searches.', noIndex: true },
  '/team-workspaces': { title: 'Team Workspaces', description: 'Manage team workspaces.', noIndex: true },
  '/subscriptions': { title: 'Subscriptions', description: 'Manage subscriptions.', noIndex: true },
  '/video-interviews': { title: 'Video Interviews', description: 'Video interview rooms.', noIndex: true },
  '/skills-marketplace': { title: 'Skills Marketplace', description: 'Browse and create gigs.', noIndex: true },
  '/freelancer-onboarding': { title: 'Onboarding', description: 'Complete your freelancer profile.', noIndex: true },
  '/careerbuddypropro': { title: 'Dashboard', description: 'Your freelancer dashboard.', noIndex: true },
  '/freelancer-dashboard': { title: 'Dashboard', description: 'Your freelancer dashboard.', noIndex: true },
  '/verification': { title: 'Get Verified', description: 'Verify your expert status.', noIndex: true },
  '/sign-contracts': { title: 'Sign Contracts', description: 'Review and sign contracts.', noIndex: true },
  '/manage-team-projects': { title: 'Team Projects', description: 'Manage team projects.', noIndex: true },
  '/share-hiring-workspace': { title: 'Hiring Workspace', description: 'Share your hiring workspace.', noIndex: true },
  '/approve-invoices': { title: 'Approve Invoices', description: 'Review and approve invoices.', noIndex: true },
};

export default seoConfig;
